import * as React from "react";
import { mergeStyleSets } from "@nuorder/components";
import { EmptyView } from "./empty-view";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { IStore } from "reducers";
import { TargetGroup } from "./target-group";
import { DATATEST } from "constants/integration";
import { formatMessage } from "lib/globalize-util";
import { getTargetGroupsWithTargets } from "reducers/selectors/collection";
import { TargetGroupWithTargets } from "components/product-collection/footer/types";

interface OwnProps {}

interface ReduxProps {
    targetGroupsWithTargets: TargetGroupWithTargets[];
}

interface ReduxDispatchProps {}

export const targetsListStyles = mergeStyleSets({
    targetsListContainer: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowY: "scroll",
    },
    targetsListRowContainer: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
        paddingTop: "10px",
        paddingBottom: "10px",
    },
    targetsListRowTinyColumn: {
        width: "20px",
        marginRight: "8px",
    },
    targetsListRowSmallColumn: {
        width: "70px",
        minWidth: "70px",
        marginRight: "8px",
    },
    targetsListRowLargeColumn: {
        width: "260px",
        minWidth: "260px",
        marginRight: "8px",
    },
    targetsListRowMediumColumn: {
        width: "120px",
        minWidth: "120px",
        marginRight: "8px",
    },
    targetsListRowMediumLargeColumn: {
        // Since this is merging of TWO columns, add 8px of margin into the width
        width: "388px",
        marginRight: "8px",
    },
    targetsListRowShadowColumn: {
        marginRight: "8px",
    },
});

const TargetsListComponent: React.FunctionComponent<OwnProps & ReduxProps & ReduxDispatchProps> = ({
    targetGroupsWithTargets,
}) => {
    if (targetGroupsWithTargets.length === 0) {
        return <EmptyView />;
    }

    return (
        <>
            <div className={targetsListStyles.targetsListRowContainer} style={{ fontWeight: "bold" }}>
                <div className={targetsListStyles.targetsListRowTinyColumn}> </div>
                <div className={targetsListStyles.targetsListRowSmallColumn}>{formatMessage("Active")}</div>
                <div className={targetsListStyles.targetsListRowLargeColumn}>{formatMessage("Target name")}</div>
                <div className={targetsListStyles.targetsListRowMediumColumn}>{formatMessage("Type")}</div>
                <div className={targetsListStyles.targetsListRowMediumColumn}>{formatMessage("Target")}</div>
                <div className={targetsListStyles.targetsListRowSmallColumn}>{formatMessage("Created")}</div>
                <div className={targetsListStyles.targetsListRowSmallColumn}>{formatMessage("Modified")}</div>
                <div className={targetsListStyles.targetsListRowTinyColumn}> </div>
            </div>
            <div
                data-test={DATATEST.ASSORTMENTS.FOOTER.MANAGE_TARGETS.BUDGET_GROUP_LIST_CONTAINER}
                className={targetsListStyles.targetsListContainer}
            >
                {targetGroupsWithTargets.map((targetGroup) => (
                    <TargetGroup key={targetGroup.id} targetGroupId={targetGroup.id} />
                ))}
            </div>
        </>
    );
};

const mapStateToProps = (state: IStore) => {
    return {
        targetGroupsWithTargets: getTargetGroupsWithTargets(state),
    };
};

export const TargetsList = withRouter(
    connect<ReduxProps, ReduxDispatchProps, OwnProps>(mapStateToProps, null)(TargetsListComponent)
);
